import { Box, Button, Checkbox, Stack } from '@chakra-ui/react'
import {
  CollectionReference,
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore'
import { chain } from 'lodash'
import { useState } from 'react'
import { CSVDownload } from 'react-csv'
import useHandleError from '../../../hooks/useHandleError'
import FirestoreUser, { diagnosisTitles } from '../../../types/FirestoreUser'
import { primaryServices } from '../../../utils/firebaseServiceContext'

export default function ExportUsers() {
  const [data, setData] = useState<any>()
  const [loading, setLoading] = useState(false)
  const handleError = useHandleError()
  const [includeDeceased, setIncludeDeceased] = useState(false)

  async function handleExport() {
    setLoading(true)
    try {
      const snap = await getDocs(
        query(
          collection(
            primaryServices.firestore,
            'users',
          ) as CollectionReference<FirestoreUser>,
          where('profile', '!=', null),
        ),
      )

      setData(
        chain(snap.docs)
          .map((doc) => doc.data())
          .filter((user) => {
            if (includeDeceased) return true
            return !user.lockedDate
          })
          .orderBy((user) => user.email, 'asc')
          .map((user) => {
            return {
              Email: user.email,
              'First Name': user.profile?.firstName,
              'Last Name': user.profile?.lastName,
              'State/Province': user.profile?.state || '',
              City: user.profile?.city || '',
              Diagnosis:
                diagnosisTitles[user.profile?.diagnosis || 'administrator'],
              Deceased: user.lockedDate ? 'YES' : 'NO',
            }
          })
          .value(),
      )
    } catch (e) {
      handleError(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Stack>
      <Checkbox
        isChecked={includeDeceased}
        onChange={(e) => setIncludeDeceased(e.target.checked)}
      >
        Include Deceased
      </Checkbox>
      <Box>
        <Button isLoading={loading} isDisabled={loading} onClick={handleExport}>
          Export to CSV
        </Button>
      </Box>
      {data && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - react-csv types incompatible with React 18
        <CSVDownload
          data={data}
          target='_blank'
          filename='ALS_Registry_Users.csv'
        />
      )}
    </Stack>
  )
}
